import React from 'react';
import { useParams } from 'react-router';
import { useUser } from '../hooks';
import { useUserManagementContext } from '../context/UserManagementContext';
import UserDetailsSidebar from '../components/UserDetailsSidebar';
import UserDetailsInfo from '../components/UserDetailsInfo';
import { Grid } from '@material-ui/core';
import { UserDetailsSkeleton } from '../components/UserDetailsSkeleton';
import { UserCredentialsDrawer } from '../components/drawers/UserCredentialsDrawer';
import { ApiError } from '../../../shared/api/apiService';
import { CustomErrorPage } from '../../CustomErrorPage';

export default function UserDetailsPage() {
  const { id: userId } = useParams();
  const { organizations, templates, handleEditUserWithData } =
    useUserManagementContext();
  const { data: userData, isLoading, isError, error } = useUser(userId);

  if (isLoading) {
    return <UserDetailsSkeleton />;
  }

  if (isError) {
    const status = error instanceof ApiError && error.status === 403 ? '403' : '500';
    return <CustomErrorPage status={status} statusMessage={status === '403' ? 'Forbidden' : 'Something went wrong'} />;
  }

  return (
    <>
      <Grid container style={{ height: '100%' }} spacing={0}>
        <Grid item xs={5}>
          <UserDetailsInfo
            userData={userData}
            isLoading={isLoading}
            organizations={organizations}
          />
        </Grid>
        <Grid item xs={7}>
          <UserDetailsSidebar
            userData={userData}
            templates={templates}
            isLoading={isLoading}
            handleEditUserWithData={handleEditUserWithData}
          />
        </Grid>
      </Grid>
      <UserCredentialsDrawer />
    </>
  );
}
